// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PFS-Page__PredictiveBundle-Management .BC-Filters-ConnectedFilterControl__RightContainer {
  display: flex;
  justify-content: flex-end;
  padding: 8px 20px;
  align-items: center;
  gap: 8px;
  box-shadow: 0px -1px 0px 0px rgba(225, 227, 229, 1) inset;
}

.PFS-Page__PredictiveBundle-Management .Polaris-Page {
  max-width: 1168px;
}

.PFS-Page__PredictiveBundle-Management .BC-Filters-ConnectedFilterControl__RightContainer .refresh {
  padding: 0 8px;
}

.PFS-Page__PredictiveBundle-Management .pfs-feature-lock-card {
  padding: 50px 93px;
  margin: unset;
}

.PFS-Page__PredictiveBundle-Management .refresh .Polaris-Button__Icon {
  height: 14px;
}
.PFS-Page__PredictiveBundle-Management thead {
  background: var(--surface-subdued, #fafbfb);
}

.PFS-Page__PredictiveBundle-Management thead tr td {
  border-top: 1px solid var(--border-divider, #e1e3e5);
  border-bottom: 1px solid var(--border-divider, #e1e3e5);
}
.PFS-Page__PredictiveBundle-Management thead tr td:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-left: 1px solid var(--border-divider, #e1e3e5);
}
.PFS-Page__PredictiveBundle-Management thead tr td div {
  color: rgba(109, 113, 117, 1);
}

.PFS-Page__PredictiveBundle-Management thead tr td:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: 1px solid var(--border-divider, #e1e3e5);
}

.PFS-Page__PredictiveBundle-Management table tr td.Polaris-DataTable__Cell--actions {
  padding-left: 0;
  padding-right: 0;
}
.PFS-Page__PredictiveBundle-Management table tr td.Polaris-DataTable__Cell--actions > div {
  display: flex;
  justify-content: center;
}

.PFS-Page__PredictiveBundle-Management table .Polaris-DataTable__Cell--status .Polaris-Badge {
  font-weight: 500;
  font-size: 12px;
}

.PFS-Page__PredictiveBundle-Management table .premium-badge-crown {
  border-radius: 4px;
}

.PFS-Page__PredictiveBundle-Management table .premium-badge-crown span {
  font-weight: 600;
  font-size: 12px;
  color: #FF3345;
  display: flex;
  align-items: center;
  gap: 2px;
}

.PFS-Page__PredictiveBundle-Management .group_btn button svg {
  fill: var(--p-icon);
}
.PFS-Page__PredictiveBundle-Management .BC-Filters .search {
  min-width: 300px;
}

.PFS-Page__PredictiveBundle-Management .Polaris-DataTable__Cell--type .Polaris-Badge {
  font-weight: 400;
  padding: 2px 8px;
  border-radius: 4px;
  background: #edeeef;
  color: #6d7175;
  font-size: 12px;
  line-height: 16px;
}

.PFS-Page__PredictiveBundle-Management .list-widgets thead .Polaris-DataTable__Cell--header {
  font-size: 12px;
}

.PFS-Page__PredictiveBundle-Management .BC-Filters__TagsContainer {
  padding-left: 16px;
  padding-top: 1px;
}

.PFS-Page__PredictiveBundle-Management .BC-Filters__TagsContainer > div > div {
  padding-top: 15px;
}

.BC-Popover__PredictiveBundle-Filters-Market .breakLine {
  padding: 16px 0 0 0;
  display: flex;
  justify-content: space-between;
}

.BC-Popover__PredictiveBundle-Filters-Market .Polaris-Tag button {
  display: flex;
  align-items: center;
  margin: unset;
  text-align: right;
  justify-content: flex-end;
}

.BC-Popover__PredictiveBundle-Filters-Market {
  width: 210px;
}


.BC-Popover__PredictiveBundle-Filters-Market .Polaris-ChoiceList ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

/* item */
.PFS-PredictiveBundleItem_BundleType .Polaris-Card {
  max-width: 936px;
}

.PFS-PredictiveBundleItem_BundleType .Polaris-Card .btn-title-content {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.PFS-PredictiveBundleItem_BundleType .Polaris-Card .btn-content {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding: 6px 4px 4px;
}

.PFS-PredictiveBundleItem_BundleType .Polaris-Grid {
  gap: 20px;
}

.PFS-PredictiveBundleItem_BundleType .Polaris-Card__Section {
  padding: 24px;
}

.PFS-PredictiveBundleItem_BundleType .recommendation-type--select {
  display: flex;
}
.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button {
  padding: 12px !important;
}
.PFS-PredictiveBundleItem_BundleType .button-large > button {
  border-radius: 8px;
  background: rgba(250, 251, 251, 1);
  border: 1px solid rgba(250, 251, 251, 1);
}

.PFS-PredictiveBundleItem_BundleType .button-large > button:hover,
.PFS-PredictiveBundleItem_BundleType .isSelected > button {
  border: 1px solid rgba(31, 81, 153, 1);
  background: rgba(229, 239, 253, 1);
}

.PFS-PredictiveBundleItem_BundleType .button-large .btn-title .Polaris-Badge {
  background: #ff30001a;
  font-size: 12px;
  font-weight: 400;
}

.PFS-PredictiveBundleItem_BundleType .button-large .btn-title .Polaris-Badge > span {
  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);
  background-clip: text;
  -webkit-text-fill-color: #0000;
  font-weight: 600;
  align-items: center;
  display: flex;
  font-size: 12px;
  gap: 4px;
}

.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button__Text {
  width: 100%;
}

.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content > div {
  margin-top: 16px;
}

.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content .btn-img {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
}

.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content .main-img {
  height: 90px;
  width: 232px;
}

.PFS-PredictiveBundleItem_BundleType .button-large .bundle-personalized .main-img {
  width: 346px;
}

.PFS-PredictiveBundleItem_BundleType
  .button-large
  .recommendation-type--select-content
  .btn-img
  > div {
  position: absolute;
  top: -10px;
  left: auto;
  right: auto;
  border: 1px solid rgba(201, 204, 207, 1);
  background: rgba(255, 255, 255, 1);
  width: auto;
  height: 24px;
  padding: 4px 8px;
  font-weight: 600;
  border-radius: 4px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  gap: 4px;
}
.PFS-PredictiveBundleItem_BundleType .button-large .bundle-personalized .btn-img > div {
  top: 0;
}

.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button__Content {
  display: block;
}

.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button {
  align-items: unset;
}

.PFS-PredictiveBundleItem_BundleType .button-type-lock .btn-img,
.PFS-PredictiveBundleItem_BundleType .button-type-lock .btn-title {
  opacity: 0.5;
}

.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell,
.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell .button-large,
.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell .button-large .Polaris-Button {
  height: 100%;
}
.PFS-PredictiveBundleItem_BundleType .button-large .btn-unlock {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-decoration: underline;
  color: rgba(31, 81, 153, 1);
}

.PFS-PredictiveBundleItem .setup-general-settings {
  padding: 4px;
}
.PFS-PredictiveBundleItem .setup-general-settings .settings {
  display: grid;
}

.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-content {
  padding: 12px;
  background-color: #f6f6f7;
  border-radius: 8px;
  margin-top: 10px;
}

.PFS-PredictiveBundleItem
  .setup-general-settings
  .settings
  .item.product
  .settings-bundle-based-products {
  display: flex;
  gap: 8px;
}
.PFS-PredictiveBundleItem .setup-general-settings .tiered-bundle .Polaris-ChoiceList__Choices,
.PFS-PredictiveBundleItem
  .setup-general-settings
  .settings
  .item.product
  .choice-bundle-based
  .Polaris-ChoiceList__Choices {
  display: flex;
  gap: 32px;
  align-items: center;
}

.PFS-PredictiveBundleItem
  .setup-general-settings
  .settings
  .item.product
  .settings-tiered-based-products {
  background-color: #f6f6f7;
  padding: 12px;
  border-radius: 8px;
}

.PFS-PredictiveBundleItem
  .setup-general-settings
  .settings
  .item.product
  .settings-bundle-based-products
  .select-bundle-based {
  flex-basis: 288px;
}
.PFS-PredictiveBundleItem
  .setup-general-settings
  .settings
  .item.product
  .settings-bundle-based-products
  .select-bundle-based-products {
  flex-grow: 1;
}

.PFS-PredictiveBundleItem
  .setup-general-settings
  .settings
  .item.product
  .settings-bundle-based-products
  .select-bundle-based-products
  .Polaris-TextField__Suffix
  .Polaris-Icon__Svg {
  fill: #babec3;
}

.PFS-PredictiveBundleItem .setup-general-settings .field-helper {
  color: var(--p-text-subdued);
}

.PFS-PredictiveBundleItem .setup-general-settings .tiered-bundle,
.PFS-PredictiveBundleItem .setup-general-settings .volume-discount {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.PFS-PredictiveBundleItem .setup-general-settings .discount-item > div {
  display: flex;
  gap: 12px;
}

.PFS-PredictiveBundleItem .setup-general-settings .discount-item > div > p {
  margin-top: 10px;
}

.PFS-PredictiveBundleItem .setup-general-settings .discount-item > div .remove-icon {
  display: flex;
  align-items: center;
  margin-top: 6px;
  max-height: 28px;
}

.PFS-PredictiveBundleItem .setup-general-settings .tiered-bundle .button .Polaris-Button__Text {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.PFS-PredictiveBundleItem .setup-general-settings .tiered-bundle .items {
  background-color: #f6f6f7;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.PFS-PredictiveBundleItem .setup-general-settings .tiered-bundle .discount-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.PFS-PredictiveBundleItem .setup-general-settings .discount-item > div > div:not(.remove-icon) {
  width: 33%;
}

.PFS-PredictiveBundleItem .setup-general-settings .volume-discount .discount-item .remove-icon {
  display: flex;
  align-items: center;
  margin-top: 24px;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list {
  border: 1px dashed rgba(225, 227, 229, 1);
  border-radius: 4px;
  margin-top: 8px;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list ul {
  list-style-type: none;
  padding: unset;
  margin: unset;
  align-items: center;
}
.PFS-PredictiveBundleItem .rule-group-block .product-list ul li {
  padding: 8px;
  margin-left: unset;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list ul li .Polaris-Stack__Item:first-child {
  padding-left: 4px;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list ul li .Polaris-Stack__Item:nth-child(3) {
  flex: 1 1;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item__Action .Polaris-Icon svg {
  fill: rgba(140, 145, 150, 1);
}

.PFS-PredictiveBundleItem
  .rule-group-block
  .product-list
  .product-item__Action
  .Polaris-Icon:hover
  svg {
  fill: var(--p-icon);
}

.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item {
  background: var(--surface-default, #fff);
  /* Divider/Bottom */
  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;
}

.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item:last-child {
  /* Divider/Bottom */
  box-shadow: none;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list-note {
  margin-top: 8px;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list-note .prefix {
  font-weight: 600;
  color: #d72c0d;
}
.PFS-PredictiveBundleItem .exclude-products-list .product-list-note .number-limit {
  font-weight: 600;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list {
  display: flex;
  gap: 40px;
  margin-top: 10px;
  max-height: 580px;
  overflow-y: auto;
  padding-right: 8px;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list .column {
  flex: 1;
}

.PFS-PredictiveBundleItem
  .exclude-products-list
  .product-list
  .column
  .Polaris-Stack--alignmentCenter
  .Polaris-Stack__Item:last-child {
  margin-left: auto;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list .divider {
  border-bottom: 1px solid var(--p-divider);
  margin-top: 8px;
  margin-bottom: 10px;
}

.PFS-PredictiveBundleItem
  .exclude-products-list
  .product-list
  .product-item__Name
  .Polaris-Link--removeUnderline:hover {
  text-decoration: none;
}

.PFS-PredictiveBundleItem .exclude-products-list .product-list .product-item__Action {
  padding-top: 8px;
}

.PFS-PredictiveBundleItem
  .exclude-products-list
  .product-list
  .product-item__Action
  .Polaris-Icon
  svg {
  fill: rgba(140, 145, 150, 1);
}

.PFS-PredictiveBundleItem
  .exclude-products-list
  .product-list
  .product-item__Action
  .Polaris-Icon:hover
  svg {
  fill: var(--p-icon);
}

/* .PFS-PredictiveBundleItem .setup-general-settings .item:not(:first-child) {
  padding-top: 20px;
  border-top: 1px solid rgba(225, 227, 229, 1);
} */

.PFS-PredictiveBundleItem .setup-general-settings .item:not(:last-child) {
  padding-bottom: 24px;
}

.PFS-PredictiveBundleItem .setup-general-settings .item .field-title {
  font-weight: 600;
  line-height: 20px;
}

.PFS-PredictiveBundleItem .setup-general-settings .ai-based-primary-algorithm-helper-text {
  margin-top: 5px;
}

.PFS-PredictiveBundleItem .setup-general-settings .item .field-helper {
  line-height: 20px;
  margin-bottom: 0.5rem;
}

.PFS-PredictiveBundleItem .setup-general-settings .discount {
  display: flex;
  gap: 12px;
}

.PFS-PredictiveBundleItem .setup-general-settings .status > div,
.PFS-PredictiveBundleItem .setup-general-settings .discount > div {
  max-width: 288px;
  width: 288px;
}

.PFS-PredictiveBundleItem .setup-general-settings .placement .Polaris-ChoiceList__Choices {
  display: flex;
  gap: 32px;
}

.PFS-PredictiveBundleItem .setup-general-settings .Polaris-TextStyle--variationStrong {
  margin-bottom: 4px;
}

.PFS-PredictiveBundleItem .setup-general-settings .item > p {
  margin-bottom: 8px;
}

.PFS-PredictiveBundleItem .market-settings .field {
  display: flex;
  gap: 12px;
}
.PFS-PredictiveBundleItem .market-settings .field > div:first-child {
  max-width: 288px;
  width: 33%;
}

.PFS-PredictiveBundleItem .market-settings .field > div:first-child .Polaris-Button {
  width: 100%;
  padding: 5px 8px 5px 12px;
  display: flex;
  font-weight: 400;
  justify-content: space-between;
}

.PFS-PredictiveBundleItem .market-settings .field > div:last-child {
  width: 70%;
}

.PFS-PredictiveBundleItem .market-settings .market-note {
  color: #6d7175;
  margin-top: 4px;
}

.PFS-PredictiveBundleItem .market-settings .market-note .Polaris-Link {
  display: inline-flex;
  align-items: center;
}

.PFS-PredictiveBundleItem .bundle-display-type-items,
.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid {
  margin-top: 8px;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .Polaris-Button {
  padding: 12px !important;
  align-items: unset;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .Polaris-Button__Content {
  display: block;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-large > button {
  border-radius: 8px;
  border: 1px solid var(--p-border-subdued);
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-large > button:hover,
.PFS-PredictiveBundleItem .bundle-display-type-items .isSelected > button {
  border: 1px solid var(--p-interactive);
}

.PFS-PredictiveBundleItem
  .bundle-display-type-items
  .button-large
  .recommendation-type--select-content
  .btn-img {
  position: relative;
  width: 100%;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .btn-title {
  margin-top: 16px;
  text-align: left;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-type-lock .btn-img {
  opacity: 0.5;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid-Cell,
.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid-Cell .button-large,
.PFS-PredictiveBundleItem
  .bundle-display-type-items
  .Polaris-Grid-Cell
  .button-large
  .Polaris-Button {
  height: 100%;
}

.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .btn-unlock {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-decoration: underline;
  color: rgba(31, 81, 153, 1);
}

.PFS-PredictiveBundleItem_Placement .Polaris-Card__Section {
  padding: 24px;
}

.PFS-PredictiveBundleItem_Placement .Polaris-Banner {
  margin-bottom: 32px;
}
.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Link {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: rgba(44, 110, 203, 1);
}

.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Link .Polaris-Icon {
  margin: unset;
  width: 15px;
  height: 15px;
}

.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Banner__Content p {
  display: flex;
  gap: 3px;
}

.PFS-PredictiveBundleItem_Placement .tab-content-content .Polaris-Grid:not(:first-child),
.PFS-PredictiveBundleItem_Placement .content,
.PFS-PredictiveBundleItem_Placement .action {
  margin-top: 16px;
}

.PFS-PredictiveBundleItem_Placement .content .content-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.PFS-PredictiveBundleItem_Placement .tab-content .non-action .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
  margin-right: 8px;
}

.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField__Backdrop {
  border-radius: 8px;
  height: 44px;
}

.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField {
  height: 44px;
}

.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField .Polaris-TextField__Suffix {
  display: flex;
}

.PFS-PredictiveBundleItem_Placement .Polaris-Button .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.PFS-PredictiveBundleItem_Placement .Polaris-Button .Polaris-Icon svg {
  fill: rgba(140, 145, 150, 1);
}

.PFS-PredictiveBundleItem_Placement .Polaris-TextField .Polaris-TextField__Input:disabled {
  color: rgba(32, 34, 35, 1);
}

.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-TextField {
  align-items: unset;
  margin-top: 4px;
}

.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-TextField__Input:disabled {
  -webkit-text-fill-color: #202223 !important;
  font-family: Monaco;
}

.PFS-PredictiveBundleItem_Placement .html-placeholder textarea {
  font-size: 0.75rem;
  height: max-content !important;
  padding: 12px;
}

.PFS-PredictiveBundleItem_Placement .html-placeholder input {
  font-size: 0.75rem;
}

.PFS-PredictiveBundleItem_Placement
  .html-placeholder
  .Polaris-TextField
  .Polaris-TextField__Suffix {
  margin: unset;
  padding: 5px 4px;
}

.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-Button {
  margin: unset;
}

.PFS-PredictiveBundleItem_Placement .BC-Iframe-Container {
  border-radius: 2px;
}
.PFS-PredictiveBundleItem_Placement .banner-info .Polaris-Banner .Polaris-Banner__Content p {
  display: block !important;
}

.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Icon {
  margin: unset;
  display: inline-flex;
  vertical-align: top;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .default-settings-widget {
  color: #6d7175;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item {
  display: flex;
  padding: 10px 0;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e1e3e5;
  cursor: pointer;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item .Polaris-Icon {
  margin-right: 0;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item:hover {
  background-color: #f1f1f1;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item__name {
  font-weight: 600;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-title {
  display: flex;
  justify-content: flex-start;
  margin: -16px -20px 0;
  padding: 12px;
  align-items: center;
  border-bottom: 1px solid #e1e3e5;
  font-size: 1rem;
  font-weight: 600;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-title .btn-back {
  cursor: pointer;
  margin-right: 8px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .bundle-thumbnail-settings {
  padding: 16px;
  border: 1px solid rgba(225, 227, 229, 1);
  border-radius: 4px;
  background: rgba(250, 251, 251, 1);
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .widget-layout-settings
  .bundle-thumbnail-settings
  .product-image-wrapper {
  width: 50%;
  margin: auto;
}

.bundle-thumbnail-settings .product-image-div {
  display: grid;
  grid-gap: 4px;
  aspect-ratio: 3/4;
}

.bundle-thumbnail-settings .product-image {
  overflow: hidden;
}

.bundle-thumbnail-settings .product-image-img {
  width: 100%;
}

.bundle-thumbnail-settings .product-image-div.image-with-2 {
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: 1fr;
}

.bundle-thumbnail-settings .product-image-div.image-with-3 {
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
}

.bundle-thumbnail-settings .product-image-div.image-with-4 {
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(2, 1fr);
}

.bundle-thumbnail-settings .product-image-img-sub {
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: 100%;
  transition: transform 0.3s;
  display: block;
}

/* .bundle-thumbnail-settings .product-image-div.image-with-2 .product-image-img-sub:first-child {
  width: 100%;

  clip-path: inset(0 0 calc(50% + 2px) 0);
  margin-bottom: calc(-50% - 2px);
}

.bundle-thumbnail-settings .product-image-div.image-with-2 .product-image-img-sub:last-child {
  width: 100%;
  clip-path: inset(calc(50% + 2px) 0 0 0);
  margin-top: calc(-50% - 2px);
} */

.bundle-thumbnail-settings button {
  margin-top: 8px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .visual-editor-preview-wrapper {
  height: calc(100vh - 92px);
  width: calc(100% - 300px);
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-image-wrapper
  img[alt='plus'] {
  width: 16px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-image-card
  .product-image--has-border {
  border: 1.19px solid #e4e4e9;
}

.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .product-items-card,
.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .product-image-card {
  overflow-x: hidden;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_general-page
  .item-detail-preview {
  margin-right: 24px;
}

.PFS-PredictiveBundleItem .boost-sd__instant-search-autocomplete {
  z-index: 14;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .product-items-card {
  outline: none;
  width: 100%;
  position: relative;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_vertical-product
  .product-items-card {
  flex-direction: column;
  gap: 4px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .product-images {
  display: flex;
  gap: 4px;
  justify-content: space-between;
  align-items: center;
  max-width: 162px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .vertical .product-images {
  flex-direction: column;
  max-width: 80px !important;
}

.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .product-image-img {
  position: relative;
  display: block;
  max-width: 100%;
  object-fit: cover;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_instant-search-widget
  .recommendation-title,
.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_instant-search-widget
  .recommendation-title-left {
  margin: 0 0 20px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_vertical-product {
  padding: 32px 20%;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_vertical-product.bundle-preview_tiered-page {
  padding: 32px 27%;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_horizontal-product {
  padding: 32px 68px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .product-item {
  width: 100%;
  display: flex;
  gap: 12px;
}
.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .product-item.horizontal {
  flex-direction: column;
  max-width: 162px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .product-images
  > img {
  width: 14px;
  height: 14px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .product-tiered-items .product-item .item-detail {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 18px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .product-tiered-items .horizontal .item-detail {
  max-width: 158px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .product-tiered-items
  .horizontal
  .item-detail
  .variants
  button {
  width: 100%;
}

.PFS-PredictiveBundleItem .widget-visual-editor .product-tiered-items .horizontal .item-detail p {
  word-wrap: break-word;
  white-space: pre-wrap;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .product-images
  > div {
  border: 1.19px solid #e4e4e9;
  border-radius: 2px;
  overflow: hidden;
  height: 192px;
  min-width: 80px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .vertical
  .product-images
  > div {
  height: 96px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .selected-variants {
  padding: 8px;
  background-color: #f4f4f4;
  border-radius: 4px;
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .selected-variants
  .variant-item
  p,
.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .vertical
  .selected-variants
  .variant-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .selected-variants
  .variant-item
  > div {
  width: calc(100% / 3);
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .horizontal
  .variant-item
  > div {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .selected-variants
  .variant-item
  .amount-control
  > div:not(:nth-child(2)) {
  cursor: pointer;
  display: flex;
  width: 20px;
  justify-content: center;
  align-items: center;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .variant-item
  .amount-control {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px;
  border: 1px solid #ebebeb;
  border-radius: 40px;
  background-color: #ffffff;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .horizontal
  .variant-item
  .amount-control {
  max-width: 92px;
  margin-left: auto;
  margin-top: 8px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .product-tiered-items
  .variant-item
  > div:not(:last-child) {
  font-size: 12px;
  font-weight: 500;
  color: #6d7175;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .product-tiered-items
  .product-item
  .item-detail
  .variants
  .Polaris-Button__Text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .product-tiered-items
  .product-item
  .item-detail
  .variants
  .Polaris-Icon {
  margin: unset;
}
.PFS-PredictiveBundleItem
  .widget-visual-editor
  .product-tiered-items
  .vertical
  .item-detail
  .variants {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.widget-visual-editor .visual-editor-body .bundle-preview_vertical-product .recommendation-title {
  margin-top: 40px auto !important;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_vertical-product
  .recommendation-title {
  margin: 32px auto 16px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_vertical-product
  .volume-item
  .info {
  display: flex;
}
.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_vertical-product
  .volume-item
  .info
  > div {
  width: 100%;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .discount {
  display: flex;
  justify-content: space-between;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .variant-item {
  display: flex;
  align-items: center;
  gap: 16px;
}
.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .variant-item > div {
  width: 100%;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .total {
  text-align: end !important;
}
.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .Polaris-Select__Content {
  color: black;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .Polaris-Select__Content svg {
  fill: black;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .recommendation-bundle.recommendation-bundle--instant-search-widget {
  padding-top: 40px;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .recommendation-bundle-body,
.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.PFS-PredictiveBundleItem
  .bundle-preview_product-volume-page
  .recommendation-bundle-body
  .add-to-cart {
  width: 100% !important;
  max-width: unset;
}

.PFS-PredictiveBundleItem .bundle-preview_horizontal-product > div .recommendation-bundle-body {
  width: 75%;
  max-width: 716px;
  margin: 0 !important;
}

.PFS-PredictiveBundleItem
  .bundle-preview_horizontal-product
  .recommendation-bundle-content
  > div:nth-child(2) {
  width: 25%;
  max-width: 228px;
  display: flex;
  flex-direction: column;
  margin-top: 119px;
}

.PFS-PredictiveBundleItem .bundle-preview_horizontal-product .recommendation-bundle-content {
  display: flex;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .visual-editor-body
  .bundle-preview_horizontal-product
  .recommendation-title {
  margin: 32px auto 12px;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item {
  border-radius: 8px;
  padding: 24px 20px;
  border: 1px solid #d2d5d8;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item-highlight {
  position: relative;
  border: 1px solid #d2d5d8;
}

.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item-highlight > .highlight {
  position: absolute;
  top: -15px;
  border-radius: 2px;
}

.PFS-PredictiveBundleItem
  .bundle-preview_product-volume-page
  .Polaris-RadioButton__Input:checked
  + .Polaris-RadioButton__Backdrop {
  border-color: #008060;
}
.PFS-PredictiveBundleItem
  .bundle-preview_product-volume-page
  .Polaris-RadioButton__Backdrop::before {
  background-color: var(--before-color, black);
}

.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-wrapper,
.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-inner {
  justify-content: center;
  align-items: center;
}

.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .cart {
  width: 100%;
  box-shadow: inset 0 1px 0 #e4e5e7;
  padding-top: 12px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .cart-inner {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .boost-sd__instant-search-results--one-column
  .bundle-preview_instant-search-widget
  .cart-inner {
  flex-direction: column;
}

.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .total {
  width: auto;
  text-align: left;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .boost-sd__instant-search-results--one-column
  .bundle-preview_instant-search-widget
  .total {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .boost-sd__instant-search-results--one-column
  .bundle-preview_instant-search-widget
  .add-to-cart {
  width: 100% !important;
  max-width: 100%;
}

.PFS-PredictiveBundleItem .widget-visual-editor .hasAspectRatio {
  aspect-ratio: 3/4;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .boost-sd__suggestion-queries-item-product--left:before {
  content: none !important;
}

.PFS-PredictiveBundleItem .options-preview {
  align-items: center;
  display: flex;
  height: 100%;
}

.PFS-PredictiveBundleItem .options-preview-label {
  margin-right: 20px;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}

.PFS-PredictiveBundleItem .select-option-preview {
  min-width: 300px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .boost-sd__suggestion-queries-group
  .boost-sd__suggestion-queries-link {
  padding: 6px 12px;
}

@media only screen and (min-width: 1200px) {
  .PFS-PredictiveBundleItem
    .boost-sd__instant-search-results--full-width.boost-sd__instant-search-results--product-position-left
    .boost-sd__instant-search-autocomplete:not(.boost-sd__instant-search-no-product):not(
      .boost-sd__instant-search-no-other
    )
    .boost-sd__instant-search-column--products,
  .PFS-PredictiveBundleItem
    .boost-sd__instant-search-results--full-width.boost-sd__instant-search-results--product-position-right
    .boost-sd__instant-search-autocomplete:not(.boost-sd__instant-search-no-product):not(
      .boost-sd__instant-search-no-other
    )
    .boost-sd__instant-search-column--products {
    width: calc(100% - 248px);
  }

  .PFS-PredictiveBundleItem
    .boost-sd__instant-search-results--full-width
    .boost-sd__instant-search-column--others {
    width: 224px;
  }
}

/* skeleton custom */
.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText {
  height: var(--p-space-3);
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText + .Polaris-SkeletonBodyText {
  margin-top: var(--p-space-2);
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-fullWidth {
  width: 100%;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-fullWidth.hasMax {
  max-width: 200px;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-80Width {
  width: 80%;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-80Width.hasMax {
  max-width: 160px;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-60Width {
  width: 60%;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-60Width.hasMax {
  max-width: 120px;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-50Width {
  width: 50%;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-50Width.hasMax {
  max-width: 100px;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-30Width {
  width: 30%;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-30Width.hasMax {
  max-width: 60px;
}

.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-20Width {
  width: 20%;
}
.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-20Width.hasMax {
  max-width: 40px;
}

.PFS-PredictiveBundleItem .recommendation-note.instant-search-widget {
  text-align: left;
}

.PFS-PredictiveBundleItem .item-tab {
  margin-top: 16px;
  padding: 20px;
  background-color: #fafbfb;
  border-radius: 8px;
}

.PFS-PredictiveBundleItem .item-tab.tab-collapse {
  background: #ffffff;
  padding: 16px 20px;
  border: 1px solid #e1e3e5;
}

.PFS-PredictiveBundleItem .item-tab .item-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  border-radius: 8px;
}

.PFS-PredictiveBundleItem .item-tab .item-heading:hover {
  /* background-color: #f6f6f7; */
  cursor: pointer;
}

.PFS-PredictiveBundleItem .item-tab .item-heading .icon {
  width: 20px;
}

.PFS-PredictiveBundleItem .item-tab .item-heading .title {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  justify-content: flex-start;
  gap: 3px;
}

.PFS-PredictiveBundleItem .item-tab .item-heading .title .Polaris-Icon,
.PFS-PredictiveBundleItem .item-tab .item-heading .title .title-order {
  margin-right: 8px;
}

.PFS-PredictiveBundleItem .item-tab .Polaris-Collapsible {
  margin-top: 16px;
}

.BC-Page__SelectImageThumbnailModal .product-default-images {
  width: 100%;
  display: flex;
}

.BC-Page__SelectImageThumbnailModal .product-image-wrapper {
  position: relative;
  width: calc(20% - 10px);
  margin-left: 10px;
  border: var(--p-border-divider);
  border-radius: 4px;
  padding: 8px;
  min-height: 149px;
}

.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper:hover {
  border-color: var(--p-border-hovered);
}
.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper.selected {
  border-color: var(--p-interactive);
  background: rgba(229, 239, 253, 1);
}

.BC-Page__SelectImageThumbnailModal .product-image-img {
  width: 100%;
}

.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper .Polaris-Icon {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(44, 110, 203, 1);
}

.BC-Page__SelectImageThumbnailModal
  .product-default-images
  .product-image-wrapper
  .Polaris-Icon
  svg {
  fill: rgba(255, 255, 255, 1);
}

.BC-Page__SelectImageVolumeModal .Polaris-Modal-Section > div {
  display: flex;
  gap: 10px;
  align-items: start;
}

.BC-Page__SelectImageVolumeModal .product-image-div {
  max-width: 112px;
  width: 112px;
  height: 144px;
  padding: 8px;
  border: 1px solid #e1e3e5;
  border-radius: 4px;
}
.BC-Page__SelectImageVolumeModal .product-image {
  max-width: 100%;
  height: auto;
}
.custom-dropzone-bundle {
  padding-top: 0;
}

.custom-dropzone-bundle.uploaded {
  display: flex;
  gap: 8px;
}

.custom-dropzone-bundle.uploaded .dropzone-area {
  width: 40%;
}

.custom-dropzone-bundle .dropzone-content {
  background: #e5effd;
  padding: 4px 6px;
  font-size: 12px;
  font-weight: 600;
  color: #1f5199;
  width: fit-content;
  border-radius: 4px;
  margin: 0 auto 8px;
}

.custom-dropzone-bundle .Polaris-TextStyle--variationSubdued {
  font-size: 12px;
}

.custom-dropzone-bundle.uploaded-error .Polaris-DropZone {
  color: #d82c0d;
  size: 12px;
  font-weight: 600;
  min-height: 76px;
  align-items: center;
  background-color: #fff4f4;
}

.custom-dropzone-bundle.uploaded-error
  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled),
.custom-dropzone-bundle.uploaded-error
  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled):hover::after {
  border-color: #fd5749;
}

.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error {
  text-align: center;
  font-size: 12px;
}
.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error > p:first-child {
  font-weight: 600;
}

.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error > p:last-child {
  font-weight: 400 !important;
}

/* Product */
.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_general-page-with-product-display
  .boost-sd__product-list {
  margin: 24px 32px;
  gap: 32px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_general-page-with-product-display
  .boost-sd__product-item {
  width: calc(33.33% - 32px);
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_general-page-with-product-display
  .boost-sd__product-item
  .boost-sd__product-image {
  min-height: 372px;
}

.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_general-page-with-product-display
  .boost-sd__product-item
  .product-info
  .Polaris-SkeletonBodyText.skeleton-80Width {
  max-width: none;
}

/* Tiered Discount Progress Bar */
.PFS-PredictiveBundleItem .widget-visual-editor .discount-status {
  margin-bottom: 24px;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .tiered-progress-bar {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-icon svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-label {
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-bars {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0;
  position: relative;
  width: 100%;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  position: relative;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier .tier-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  z-index: 2;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier .tier-icon svg {
  width: 28px;
  height: 28px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .tier-connector {
  width: 78%;
  height: 4px;
  background: #d2d5d8;
  position: relative;
  margin: 0 8px;
  align-self: flex-start;
  margin-top: 13px;
  z-index: 1;
  position: absolute;
  margin-left: 44px;
  margin-right: 40px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .tier-connector.active {
  background: #008060;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier .tier-label {
  text-align: center;
  background: #ffffff;
  border-radius: 6px;
  padding: 8px 12px;
  min-width: 100px;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  vertical-align: middle;
  color: #8c9196;
}

.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier.active .tier-label,
.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier.passed .tier-label {
  color: #008060;
  font-weight: 700;
}

/* Added Preview Bar */
.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar > div:first-child {
  background: #f4f4f4;
  border: 1px solid #c9cccf;
  border-radius: 6px;
  padding: 8px 14px;
  margin-top: 2px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .no-products {
  text-align: center;
  color: #6d7175;
  font-size: 12px;
  font-weight: 500;
  padding: 12px 0;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .products-preview {
  display: flex;
  align-items: center;
  gap: 12px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .product-images {
  display: flex;
  gap: 8px;
  align-items: center;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .product-image-item {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid #e1e3e5;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .product-image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .items-count {
  font-size: 12px;
  font-weight: 500;
  color: #6d7175;
  flex-shrink: 0;
}

.PFS-PredictiveBundleItem .bundle-preview_tiered-page .add-to-cart {
  padding: 12px !important;
  max-width: none;
  border-radius: 80px;
}

.PFS-PredictiveBundleItem .bundle-preview_vertical-product .add-to-cart {
  width: 100%;
}

.PFS-PredictiveBundleItem .bundle-preview_horizontal-product .add-to-cart {
  margin: 0 auto !important;
  min-width: 112px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .see-all-link {
  margin-left: auto;
  background: none;
  border: none;
  color: #2c6ecb;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  padding: 0;
  flex-shrink: 0;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .see-all-link:hover {
  text-decoration: underline;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .total-price-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0;
}
.PFS-PredictiveBundleItem
  .widget-visual-editor
  .bundle-preview_horizontal-product
  .added-preview-bar
  .total-price-section {
  flex-direction: column;
  gap: 4px;
  margin-top: 16px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .total-label {
  font-size: 16px;
  font-weight: 400;
  color: #202223;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .price-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .price-after-discount {
  font-size: 16px;
  font-weight: 600;
  font-family: Poppins;
  color: #202223;
}

.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .price-before-discount {
  font-size: 14px;
  font-weight: 400;
  color: #6d7175;
  font-family: Poppins;
  text-decoration: line-through;
}
`, "",{"version":3,"sources":["webpack://./src/styles/bundle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oDAAoD;EACpD,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,qDAAqD;AACvD;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;;EAEE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sEAAsE;EACtE,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,wCAAwC;EACxC,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,MAAM;AACR;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;EAGE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;EAKE,aAAa;EACb,QAAQ;AACV;AACA;;;;;;;EAOE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;;EAKE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;;;;EAME,iBAAiB;AACnB;AACA;;;;;;EAME,YAAY;AACd;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;EAKE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,4BAA4B;AAC9B;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;;;;EAKE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;EAOE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;;;;EAKE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;EAKE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;EAKE,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;;;EAKE,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;;;EAQE,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;;EAKE,WAAW;EACX,aAAa;EACb,SAAS;AACX;AACA;;;;;EAKE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;;;;;;;EAOE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;;;;;EAME,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;;;;;EAKE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;;;;;;;;;;;EAaE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,qBAAqB;AACvB;;AAEA;;;;;;;EAOE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;;;;;;;;EAQE,eAAe;EACf,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;;EAME,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;EAOE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;;;;;;;EAOE,aAAa;AACf;AACA;;;;;;EAME,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;;;;;;EAME,aAAa;AACf;AACA;;;;;;;EAOE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;EAIE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;;EAIE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;EAIE,qBAAqB;AACvB;AACA;;;EAGE,4CAA4C;AAC9C;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;EAKE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;EAKE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE;;;;;;;;;;;;IAYE,yBAAyB;EAC3B;;EAEA;;;IAGE,YAAY;EACd;AACF;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;;;;EAIE,iBAAiB;EACjB,SAAS;AACX;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,MAAM;EACN,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;;EAKE,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,6BAA6B;AAC/B","sourcesContent":[".PFS-Page__PredictiveBundle-Management .BC-Filters-ConnectedFilterControl__RightContainer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 8px 20px;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0px -1px 0px 0px rgba(225, 227, 229, 1) inset;\n}\n\n.PFS-Page__PredictiveBundle-Management .Polaris-Page {\n  max-width: 1168px;\n}\n\n.PFS-Page__PredictiveBundle-Management .BC-Filters-ConnectedFilterControl__RightContainer .refresh {\n  padding: 0 8px;\n}\n\n.PFS-Page__PredictiveBundle-Management .pfs-feature-lock-card {\n  padding: 50px 93px;\n  margin: unset;\n}\n\n.PFS-Page__PredictiveBundle-Management .refresh .Polaris-Button__Icon {\n  height: 14px;\n}\n.PFS-Page__PredictiveBundle-Management thead {\n  background: var(--surface-subdued, #fafbfb);\n}\n\n.PFS-Page__PredictiveBundle-Management thead tr td {\n  border-top: 1px solid var(--border-divider, #e1e3e5);\n  border-bottom: 1px solid var(--border-divider, #e1e3e5);\n}\n.PFS-Page__PredictiveBundle-Management thead tr td:first-child {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  border-left: 1px solid var(--border-divider, #e1e3e5);\n}\n.PFS-Page__PredictiveBundle-Management thead tr td div {\n  color: rgba(109, 113, 117, 1);\n}\n\n.PFS-Page__PredictiveBundle-Management thead tr td:last-child {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-right: 1px solid var(--border-divider, #e1e3e5);\n}\n\n.PFS-Page__PredictiveBundle-Management table tr td.Polaris-DataTable__Cell--actions {\n  padding-left: 0;\n  padding-right: 0;\n}\n.PFS-Page__PredictiveBundle-Management table tr td.Polaris-DataTable__Cell--actions > div {\n  display: flex;\n  justify-content: center;\n}\n\n.PFS-Page__PredictiveBundle-Management table .Polaris-DataTable__Cell--status .Polaris-Badge {\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.PFS-Page__PredictiveBundle-Management table .premium-badge-crown {\n  border-radius: 4px;\n}\n\n.PFS-Page__PredictiveBundle-Management table .premium-badge-crown span {\n  font-weight: 600;\n  font-size: 12px;\n  color: #FF3345;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.PFS-Page__PredictiveBundle-Management .group_btn button svg {\n  fill: var(--p-icon);\n}\n.PFS-Page__PredictiveBundle-Management .BC-Filters .search {\n  min-width: 300px;\n}\n\n.PFS-Page__PredictiveBundle-Management .Polaris-DataTable__Cell--type .Polaris-Badge {\n  font-weight: 400;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #edeeef;\n  color: #6d7175;\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.PFS-Page__PredictiveBundle-Management .list-widgets thead .Polaris-DataTable__Cell--header {\n  font-size: 12px;\n}\n\n.PFS-Page__PredictiveBundle-Management .BC-Filters__TagsContainer {\n  padding-left: 16px;\n  padding-top: 1px;\n}\n\n.PFS-Page__PredictiveBundle-Management .BC-Filters__TagsContainer > div > div {\n  padding-top: 15px;\n}\n\n.BC-Popover__PredictiveBundle-Filters-Market .breakLine {\n  padding: 16px 0 0 0;\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Popover__PredictiveBundle-Filters-Market .Polaris-Tag button {\n  display: flex;\n  align-items: center;\n  margin: unset;\n  text-align: right;\n  justify-content: flex-end;\n}\n\n.BC-Popover__PredictiveBundle-Filters-Market {\n  width: 210px;\n}\n\n\n.BC-Popover__PredictiveBundle-Filters-Market .Polaris-ChoiceList ul {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n/* item */\n.PFS-PredictiveBundleItem_BundleType .Polaris-Card {\n  max-width: 936px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .Polaris-Card .btn-title-content {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .Polaris-Card .btn-content {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  padding: 6px 4px 4px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .Polaris-Grid {\n  gap: 20px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .Polaris-Card__Section {\n  padding: 24px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .recommendation-type--select {\n  display: flex;\n}\n.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button {\n  padding: 12px !important;\n}\n.PFS-PredictiveBundleItem_BundleType .button-large > button {\n  border-radius: 8px;\n  background: rgba(250, 251, 251, 1);\n  border: 1px solid rgba(250, 251, 251, 1);\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large > button:hover,\n.PFS-PredictiveBundleItem_BundleType .isSelected > button {\n  border: 1px solid rgba(31, 81, 153, 1);\n  background: rgba(229, 239, 253, 1);\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .btn-title .Polaris-Badge {\n  background: #ff30001a;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .btn-title .Polaris-Badge > span {\n  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);\n  background-clip: text;\n  -webkit-text-fill-color: #0000;\n  font-weight: 600;\n  align-items: center;\n  display: flex;\n  font-size: 12px;\n  gap: 4px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button__Text {\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content > div {\n  margin-top: 16px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content .btn-img {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .recommendation-type--select-content .main-img {\n  height: 90px;\n  width: 232px;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .bundle-personalized .main-img {\n  width: 346px;\n}\n\n.PFS-PredictiveBundleItem_BundleType\n  .button-large\n  .recommendation-type--select-content\n  .btn-img\n  > div {\n  position: absolute;\n  top: -10px;\n  left: auto;\n  right: auto;\n  border: 1px solid rgba(201, 204, 207, 1);\n  background: rgba(255, 255, 255, 1);\n  width: auto;\n  height: 24px;\n  padding: 4px 8px;\n  font-weight: 600;\n  border-radius: 4px;\n  font-size: 12px;\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n}\n.PFS-PredictiveBundleItem_BundleType .button-large .bundle-personalized .btn-img > div {\n  top: 0;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button__Content {\n  display: block;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-large .Polaris-Button {\n  align-items: unset;\n}\n\n.PFS-PredictiveBundleItem_BundleType .button-type-lock .btn-img,\n.PFS-PredictiveBundleItem_BundleType .button-type-lock .btn-title {\n  opacity: 0.5;\n}\n\n.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell,\n.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell .button-large,\n.PFS-PredictiveBundleItem_BundleType .Polaris-Grid-Cell .button-large .Polaris-Button {\n  height: 100%;\n}\n.PFS-PredictiveBundleItem_BundleType .button-large .btn-unlock {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-decoration: underline;\n  color: rgba(31, 81, 153, 1);\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings {\n  padding: 4px;\n}\n.PFS-PredictiveBundleItem .setup-general-settings .settings {\n  display: grid;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .settings .item.product .settings-content {\n  padding: 12px;\n  background-color: #f6f6f7;\n  border-radius: 8px;\n  margin-top: 10px;\n}\n\n.PFS-PredictiveBundleItem\n  .setup-general-settings\n  .settings\n  .item.product\n  .settings-bundle-based-products {\n  display: flex;\n  gap: 8px;\n}\n.PFS-PredictiveBundleItem .setup-general-settings .tiered-bundle .Polaris-ChoiceList__Choices,\n.PFS-PredictiveBundleItem\n  .setup-general-settings\n  .settings\n  .item.product\n  .choice-bundle-based\n  .Polaris-ChoiceList__Choices {\n  display: flex;\n  gap: 32px;\n  align-items: center;\n}\n\n.PFS-PredictiveBundleItem\n  .setup-general-settings\n  .settings\n  .item.product\n  .settings-tiered-based-products {\n  background-color: #f6f6f7;\n  padding: 12px;\n  border-radius: 8px;\n}\n\n.PFS-PredictiveBundleItem\n  .setup-general-settings\n  .settings\n  .item.product\n  .settings-bundle-based-products\n  .select-bundle-based {\n  flex-basis: 288px;\n}\n.PFS-PredictiveBundleItem\n  .setup-general-settings\n  .settings\n  .item.product\n  .settings-bundle-based-products\n  .select-bundle-based-products {\n  flex-grow: 1;\n}\n\n.PFS-PredictiveBundleItem\n  .setup-general-settings\n  .settings\n  .item.product\n  .settings-bundle-based-products\n  .select-bundle-based-products\n  .Polaris-TextField__Suffix\n  .Polaris-Icon__Svg {\n  fill: #babec3;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .field-helper {\n  color: var(--p-text-subdued);\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .tiered-bundle,\n.PFS-PredictiveBundleItem .setup-general-settings .volume-discount {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .discount-item > div {\n  display: flex;\n  gap: 12px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .discount-item > div > p {\n  margin-top: 10px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .discount-item > div .remove-icon {\n  display: flex;\n  align-items: center;\n  margin-top: 6px;\n  max-height: 28px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .tiered-bundle .button .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .tiered-bundle .items {\n  background-color: #f6f6f7;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .tiered-bundle .discount-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .discount-item > div > div:not(.remove-icon) {\n  width: 33%;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .volume-discount .discount-item .remove-icon {\n  display: flex;\n  align-items: center;\n  margin-top: 24px;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list {\n  border: 1px dashed rgba(225, 227, 229, 1);\n  border-radius: 4px;\n  margin-top: 8px;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list ul {\n  list-style-type: none;\n  padding: unset;\n  margin: unset;\n  align-items: center;\n}\n.PFS-PredictiveBundleItem .rule-group-block .product-list ul li {\n  padding: 8px;\n  margin-left: unset;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list ul li .Polaris-Stack__Item:first-child {\n  padding-left: 4px;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list ul li .Polaris-Stack__Item:nth-child(3) {\n  flex: 1 1;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item__Action .Polaris-Icon svg {\n  fill: rgba(140, 145, 150, 1);\n}\n\n.PFS-PredictiveBundleItem\n  .rule-group-block\n  .product-list\n  .product-item__Action\n  .Polaris-Icon:hover\n  svg {\n  fill: var(--p-icon);\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item {\n  background: var(--surface-default, #fff);\n  /* Divider/Bottom */\n  box-shadow: 0px -1px 0px 0px #e1e3e5 inset;\n}\n\n.PFS-PredictiveBundleItem .rule-group-block .product-list .product-item:last-child {\n  /* Divider/Bottom */\n  box-shadow: none;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list-note {\n  margin-top: 8px;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list-note .prefix {\n  font-weight: 600;\n  color: #d72c0d;\n}\n.PFS-PredictiveBundleItem .exclude-products-list .product-list-note .number-limit {\n  font-weight: 600;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list {\n  display: flex;\n  gap: 40px;\n  margin-top: 10px;\n  max-height: 580px;\n  overflow-y: auto;\n  padding-right: 8px;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list .column {\n  flex: 1;\n}\n\n.PFS-PredictiveBundleItem\n  .exclude-products-list\n  .product-list\n  .column\n  .Polaris-Stack--alignmentCenter\n  .Polaris-Stack__Item:last-child {\n  margin-left: auto;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list .divider {\n  border-bottom: 1px solid var(--p-divider);\n  margin-top: 8px;\n  margin-bottom: 10px;\n}\n\n.PFS-PredictiveBundleItem\n  .exclude-products-list\n  .product-list\n  .product-item__Name\n  .Polaris-Link--removeUnderline:hover {\n  text-decoration: none;\n}\n\n.PFS-PredictiveBundleItem .exclude-products-list .product-list .product-item__Action {\n  padding-top: 8px;\n}\n\n.PFS-PredictiveBundleItem\n  .exclude-products-list\n  .product-list\n  .product-item__Action\n  .Polaris-Icon\n  svg {\n  fill: rgba(140, 145, 150, 1);\n}\n\n.PFS-PredictiveBundleItem\n  .exclude-products-list\n  .product-list\n  .product-item__Action\n  .Polaris-Icon:hover\n  svg {\n  fill: var(--p-icon);\n}\n\n/* .PFS-PredictiveBundleItem .setup-general-settings .item:not(:first-child) {\n  padding-top: 20px;\n  border-top: 1px solid rgba(225, 227, 229, 1);\n} */\n\n.PFS-PredictiveBundleItem .setup-general-settings .item:not(:last-child) {\n  padding-bottom: 24px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .item .field-title {\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .ai-based-primary-algorithm-helper-text {\n  margin-top: 5px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .item .field-helper {\n  line-height: 20px;\n  margin-bottom: 0.5rem;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .discount {\n  display: flex;\n  gap: 12px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .status > div,\n.PFS-PredictiveBundleItem .setup-general-settings .discount > div {\n  max-width: 288px;\n  width: 288px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .placement .Polaris-ChoiceList__Choices {\n  display: flex;\n  gap: 32px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .Polaris-TextStyle--variationStrong {\n  margin-bottom: 4px;\n}\n\n.PFS-PredictiveBundleItem .setup-general-settings .item > p {\n  margin-bottom: 8px;\n}\n\n.PFS-PredictiveBundleItem .market-settings .field {\n  display: flex;\n  gap: 12px;\n}\n.PFS-PredictiveBundleItem .market-settings .field > div:first-child {\n  max-width: 288px;\n  width: 33%;\n}\n\n.PFS-PredictiveBundleItem .market-settings .field > div:first-child .Polaris-Button {\n  width: 100%;\n  padding: 5px 8px 5px 12px;\n  display: flex;\n  font-weight: 400;\n  justify-content: space-between;\n}\n\n.PFS-PredictiveBundleItem .market-settings .field > div:last-child {\n  width: 70%;\n}\n\n.PFS-PredictiveBundleItem .market-settings .market-note {\n  color: #6d7175;\n  margin-top: 4px;\n}\n\n.PFS-PredictiveBundleItem .market-settings .market-note .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items,\n.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid {\n  margin-top: 8px;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .Polaris-Button {\n  padding: 12px !important;\n  align-items: unset;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .Polaris-Button__Content {\n  display: block;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-large > button {\n  border-radius: 8px;\n  border: 1px solid var(--p-border-subdued);\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-large > button:hover,\n.PFS-PredictiveBundleItem .bundle-display-type-items .isSelected > button {\n  border: 1px solid var(--p-interactive);\n}\n\n.PFS-PredictiveBundleItem\n  .bundle-display-type-items\n  .button-large\n  .recommendation-type--select-content\n  .btn-img {\n  position: relative;\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .btn-title {\n  margin-top: 16px;\n  text-align: left;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-type-lock .btn-img {\n  opacity: 0.5;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid-Cell,\n.PFS-PredictiveBundleItem .bundle-display-type-items .Polaris-Grid-Cell .button-large,\n.PFS-PredictiveBundleItem\n  .bundle-display-type-items\n  .Polaris-Grid-Cell\n  .button-large\n  .Polaris-Button {\n  height: 100%;\n}\n\n.PFS-PredictiveBundleItem .bundle-display-type-items .button-large .btn-unlock {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-decoration: underline;\n  color: rgba(31, 81, 153, 1);\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Card__Section {\n  padding: 24px;\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Banner {\n  margin-bottom: 32px;\n}\n.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Link {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 400;\n  color: rgba(44, 110, 203, 1);\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Link .Polaris-Icon {\n  margin: unset;\n  width: 15px;\n  height: 15px;\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Banner__Content p {\n  display: flex;\n  gap: 3px;\n}\n\n.PFS-PredictiveBundleItem_Placement .tab-content-content .Polaris-Grid:not(:first-child),\n.PFS-PredictiveBundleItem_Placement .content,\n.PFS-PredictiveBundleItem_Placement .action {\n  margin-top: 16px;\n}\n\n.PFS-PredictiveBundleItem_Placement .content .content-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.PFS-PredictiveBundleItem_Placement .tab-content .non-action .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n  margin-right: 8px;\n}\n\n.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField__Backdrop {\n  border-radius: 8px;\n  height: 44px;\n}\n\n.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField {\n  height: 44px;\n}\n\n.PFS-PredictiveBundleItem_Placement .single-line .Polaris-TextField .Polaris-TextField__Suffix {\n  display: flex;\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Button .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Button .Polaris-Icon svg {\n  fill: rgba(140, 145, 150, 1);\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-TextField .Polaris-TextField__Input:disabled {\n  color: rgba(32, 34, 35, 1);\n}\n\n.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-TextField {\n  align-items: unset;\n  margin-top: 4px;\n}\n\n.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-TextField__Input:disabled {\n  -webkit-text-fill-color: #202223 !important;\n  font-family: Monaco;\n}\n\n.PFS-PredictiveBundleItem_Placement .html-placeholder textarea {\n  font-size: 0.75rem;\n  height: max-content !important;\n  padding: 12px;\n}\n\n.PFS-PredictiveBundleItem_Placement .html-placeholder input {\n  font-size: 0.75rem;\n}\n\n.PFS-PredictiveBundleItem_Placement\n  .html-placeholder\n  .Polaris-TextField\n  .Polaris-TextField__Suffix {\n  margin: unset;\n  padding: 5px 4px;\n}\n\n.PFS-PredictiveBundleItem_Placement .html-placeholder .Polaris-Button {\n  margin: unset;\n}\n\n.PFS-PredictiveBundleItem_Placement .BC-Iframe-Container {\n  border-radius: 2px;\n}\n.PFS-PredictiveBundleItem_Placement .banner-info .Polaris-Banner .Polaris-Banner__Content p {\n  display: block !important;\n}\n\n.PFS-PredictiveBundleItem_Placement .Polaris-Banner .Polaris-Icon {\n  margin: unset;\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .default-settings-widget {\n  color: #6d7175;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item {\n  display: flex;\n  padding: 10px 0;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e1e3e5;\n  cursor: pointer;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item .Polaris-Icon {\n  margin-right: 0;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item:hover {\n  background-color: #f1f1f1;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-item__name {\n  font-weight: 600;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-title {\n  display: flex;\n  justify-content: flex-start;\n  margin: -16px -20px 0;\n  padding: 12px;\n  align-items: center;\n  border-bottom: 1px solid #e1e3e5;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .menu-title .btn-back {\n  cursor: pointer;\n  margin-right: 8px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .widget-layout-settings .bundle-thumbnail-settings {\n  padding: 16px;\n  border: 1px solid rgba(225, 227, 229, 1);\n  border-radius: 4px;\n  background: rgba(250, 251, 251, 1);\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .widget-layout-settings\n  .bundle-thumbnail-settings\n  .product-image-wrapper {\n  width: 50%;\n  margin: auto;\n}\n\n.bundle-thumbnail-settings .product-image-div {\n  display: grid;\n  grid-gap: 4px;\n  aspect-ratio: 3/4;\n}\n\n.bundle-thumbnail-settings .product-image {\n  overflow: hidden;\n}\n\n.bundle-thumbnail-settings .product-image-img {\n  width: 100%;\n}\n\n.bundle-thumbnail-settings .product-image-div.image-with-2 {\n  grid-template-rows: repeat(2, 1fr);\n  grid-template-columns: 1fr;\n}\n\n.bundle-thumbnail-settings .product-image-div.image-with-3 {\n  grid-template-rows: 1fr 1fr;\n  grid-template-columns: 1fr 1fr;\n}\n\n.bundle-thumbnail-settings .product-image-div.image-with-4 {\n  grid-template-rows: repeat(2, 1fr);\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.bundle-thumbnail-settings .product-image-img-sub {\n  object-fit: cover;\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  transition: transform 0.3s;\n  display: block;\n}\n\n/* .bundle-thumbnail-settings .product-image-div.image-with-2 .product-image-img-sub:first-child {\n  width: 100%;\n\n  clip-path: inset(0 0 calc(50% + 2px) 0);\n  margin-bottom: calc(-50% - 2px);\n}\n\n.bundle-thumbnail-settings .product-image-div.image-with-2 .product-image-img-sub:last-child {\n  width: 100%;\n  clip-path: inset(calc(50% + 2px) 0 0 0);\n  margin-top: calc(-50% - 2px);\n} */\n\n.bundle-thumbnail-settings button {\n  margin-top: 8px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .visual-editor-preview-wrapper {\n  height: calc(100vh - 92px);\n  width: calc(100% - 300px);\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-image-wrapper\n  img[alt='plus'] {\n  width: 16px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-image-card\n  .product-image--has-border {\n  border: 1.19px solid #e4e4e9;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .product-items-card,\n.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .product-image-card {\n  overflow-x: hidden;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_general-page\n  .item-detail-preview {\n  margin-right: 24px;\n}\n\n.PFS-PredictiveBundleItem .boost-sd__instant-search-autocomplete {\n  z-index: 14;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .product-items-card {\n  outline: none;\n  width: 100%;\n  position: relative;\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_vertical-product\n  .product-items-card {\n  flex-direction: column;\n  gap: 4px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .product-images {\n  display: flex;\n  gap: 4px;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 162px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .vertical .product-images {\n  flex-direction: column;\n  max-width: 80px !important;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .visual-editor-body .product-image-img {\n  position: relative;\n  display: block;\n  max-width: 100%;\n  object-fit: cover;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_instant-search-widget\n  .recommendation-title,\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_instant-search-widget\n  .recommendation-title-left {\n  margin: 0 0 20px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_vertical-product {\n  padding: 32px 20%;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_vertical-product.bundle-preview_tiered-page {\n  padding: 32px 27%;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_horizontal-product {\n  padding: 32px 68px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .product-item {\n  width: 100%;\n  display: flex;\n  gap: 12px;\n}\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .product-item.horizontal {\n  flex-direction: column;\n  max-width: 162px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .product-images\n  > img {\n  width: 14px;\n  height: 14px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .product-tiered-items .product-item .item-detail {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .product-tiered-items .horizontal .item-detail {\n  max-width: 158px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .product-tiered-items\n  .horizontal\n  .item-detail\n  .variants\n  button {\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .product-tiered-items .horizontal .item-detail p {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .product-images\n  > div {\n  border: 1.19px solid #e4e4e9;\n  border-radius: 2px;\n  overflow: hidden;\n  height: 192px;\n  min-width: 80px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .vertical\n  .product-images\n  > div {\n  height: 96px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .selected-variants {\n  padding: 8px;\n  background-color: #f4f4f4;\n  border-radius: 4px;\n  margin-top: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .selected-variants\n  .variant-item\n  p,\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .vertical\n  .selected-variants\n  .variant-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .selected-variants\n  .variant-item\n  > div {\n  width: calc(100% / 3);\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .horizontal\n  .variant-item\n  > div {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .selected-variants\n  .variant-item\n  .amount-control\n  > div:not(:nth-child(2)) {\n  cursor: pointer;\n  display: flex;\n  width: 20px;\n  justify-content: center;\n  align-items: center;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .variant-item\n  .amount-control {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 16px;\n  border: 1px solid #ebebeb;\n  border-radius: 40px;\n  background-color: #ffffff;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .horizontal\n  .variant-item\n  .amount-control {\n  max-width: 92px;\n  margin-left: auto;\n  margin-top: 8px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .product-tiered-items\n  .variant-item\n  > div:not(:last-child) {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6d7175;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .product-tiered-items\n  .product-item\n  .item-detail\n  .variants\n  .Polaris-Button__Text {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .product-tiered-items\n  .product-item\n  .item-detail\n  .variants\n  .Polaris-Icon {\n  margin: unset;\n}\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .product-tiered-items\n  .vertical\n  .item-detail\n  .variants {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.widget-visual-editor .visual-editor-body .bundle-preview_vertical-product .recommendation-title {\n  margin-top: 40px auto !important;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_vertical-product\n  .recommendation-title {\n  margin: 32px auto 16px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_vertical-product\n  .volume-item\n  .info {\n  display: flex;\n}\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_vertical-product\n  .volume-item\n  .info\n  > div {\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .discount {\n  display: flex;\n  justify-content: space-between;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .variant-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .variant-item > div {\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .total {\n  text-align: end !important;\n}\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .Polaris-Select__Content {\n  color: black;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .Polaris-Select__Content svg {\n  fill: black;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .recommendation-bundle.recommendation-bundle--instant-search-widget {\n  padding-top: 40px;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .recommendation-bundle-body,\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.PFS-PredictiveBundleItem\n  .bundle-preview_product-volume-page\n  .recommendation-bundle-body\n  .add-to-cart {\n  width: 100% !important;\n  max-width: unset;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_horizontal-product > div .recommendation-bundle-body {\n  width: 75%;\n  max-width: 716px;\n  margin: 0 !important;\n}\n\n.PFS-PredictiveBundleItem\n  .bundle-preview_horizontal-product\n  .recommendation-bundle-content\n  > div:nth-child(2) {\n  width: 25%;\n  max-width: 228px;\n  display: flex;\n  flex-direction: column;\n  margin-top: 119px;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_horizontal-product .recommendation-bundle-content {\n  display: flex;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .visual-editor-body\n  .bundle-preview_horizontal-product\n  .recommendation-title {\n  margin: 32px auto 12px;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item {\n  border-radius: 8px;\n  padding: 24px 20px;\n  border: 1px solid #d2d5d8;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item-highlight {\n  position: relative;\n  border: 1px solid #d2d5d8;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_product-volume-page .volume-item-highlight > .highlight {\n  position: absolute;\n  top: -15px;\n  border-radius: 2px;\n}\n\n.PFS-PredictiveBundleItem\n  .bundle-preview_product-volume-page\n  .Polaris-RadioButton__Input:checked\n  + .Polaris-RadioButton__Backdrop {\n  border-color: #008060;\n}\n.PFS-PredictiveBundleItem\n  .bundle-preview_product-volume-page\n  .Polaris-RadioButton__Backdrop::before {\n  background-color: var(--before-color, black);\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-wrapper,\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-inner {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_general-page .cart-inner {\n  justify-content: center;\n  align-items: center;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .cart {\n  width: 100%;\n  box-shadow: inset 0 1px 0 #e4e5e7;\n  padding-top: 12px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .cart-inner {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .boost-sd__instant-search-results--one-column\n  .bundle-preview_instant-search-widget\n  .cart-inner {\n  flex-direction: column;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .bundle-preview_instant-search-widget .total {\n  width: auto;\n  text-align: left;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .boost-sd__instant-search-results--one-column\n  .bundle-preview_instant-search-widget\n  .total {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .boost-sd__instant-search-results--one-column\n  .bundle-preview_instant-search-widget\n  .add-to-cart {\n  width: 100% !important;\n  max-width: 100%;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .hasAspectRatio {\n  aspect-ratio: 3/4;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .boost-sd__suggestion-queries-item-product--left:before {\n  content: none !important;\n}\n\n.PFS-PredictiveBundleItem .options-preview {\n  align-items: center;\n  display: flex;\n  height: 100%;\n}\n\n.PFS-PredictiveBundleItem .options-preview-label {\n  margin-right: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.PFS-PredictiveBundleItem .select-option-preview {\n  min-width: 300px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .boost-sd__suggestion-queries-group\n  .boost-sd__suggestion-queries-link {\n  padding: 6px 12px;\n}\n\n@media only screen and (min-width: 1200px) {\n  .PFS-PredictiveBundleItem\n    .boost-sd__instant-search-results--full-width.boost-sd__instant-search-results--product-position-left\n    .boost-sd__instant-search-autocomplete:not(.boost-sd__instant-search-no-product):not(\n      .boost-sd__instant-search-no-other\n    )\n    .boost-sd__instant-search-column--products,\n  .PFS-PredictiveBundleItem\n    .boost-sd__instant-search-results--full-width.boost-sd__instant-search-results--product-position-right\n    .boost-sd__instant-search-autocomplete:not(.boost-sd__instant-search-no-product):not(\n      .boost-sd__instant-search-no-other\n    )\n    .boost-sd__instant-search-column--products {\n    width: calc(100% - 248px);\n  }\n\n  .PFS-PredictiveBundleItem\n    .boost-sd__instant-search-results--full-width\n    .boost-sd__instant-search-column--others {\n    width: 224px;\n  }\n}\n\n/* skeleton custom */\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText {\n  height: var(--p-space-3);\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText + .Polaris-SkeletonBodyText {\n  margin-top: var(--p-space-2);\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-fullWidth {\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-fullWidth.hasMax {\n  max-width: 200px;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-80Width {\n  width: 80%;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-80Width.hasMax {\n  max-width: 160px;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-60Width {\n  width: 60%;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-60Width.hasMax {\n  max-width: 120px;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-50Width {\n  width: 50%;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-50Width.hasMax {\n  max-width: 100px;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-30Width {\n  width: 30%;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-30Width.hasMax {\n  max-width: 60px;\n}\n\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-20Width {\n  width: 20%;\n}\n.PFS-PredictiveBundleItem .Polaris-SkeletonBodyText.skeleton-20Width.hasMax {\n  max-width: 40px;\n}\n\n.PFS-PredictiveBundleItem .recommendation-note.instant-search-widget {\n  text-align: left;\n}\n\n.PFS-PredictiveBundleItem .item-tab {\n  margin-top: 16px;\n  padding: 20px;\n  background-color: #fafbfb;\n  border-radius: 8px;\n}\n\n.PFS-PredictiveBundleItem .item-tab.tab-collapse {\n  background: #ffffff;\n  padding: 16px 20px;\n  border: 1px solid #e1e3e5;\n}\n\n.PFS-PredictiveBundleItem .item-tab .item-heading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n  border-radius: 8px;\n}\n\n.PFS-PredictiveBundleItem .item-tab .item-heading:hover {\n  /* background-color: #f6f6f7; */\n  cursor: pointer;\n}\n\n.PFS-PredictiveBundleItem .item-tab .item-heading .icon {\n  width: 20px;\n}\n\n.PFS-PredictiveBundleItem .item-tab .item-heading .title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  display: flex;\n  justify-content: flex-start;\n  gap: 3px;\n}\n\n.PFS-PredictiveBundleItem .item-tab .item-heading .title .Polaris-Icon,\n.PFS-PredictiveBundleItem .item-tab .item-heading .title .title-order {\n  margin-right: 8px;\n}\n\n.PFS-PredictiveBundleItem .item-tab .Polaris-Collapsible {\n  margin-top: 16px;\n}\n\n.BC-Page__SelectImageThumbnailModal .product-default-images {\n  width: 100%;\n  display: flex;\n}\n\n.BC-Page__SelectImageThumbnailModal .product-image-wrapper {\n  position: relative;\n  width: calc(20% - 10px);\n  margin-left: 10px;\n  border: var(--p-border-divider);\n  border-radius: 4px;\n  padding: 8px;\n  min-height: 149px;\n}\n\n.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper:hover {\n  border-color: var(--p-border-hovered);\n}\n.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper.selected {\n  border-color: var(--p-interactive);\n  background: rgba(229, 239, 253, 1);\n}\n\n.BC-Page__SelectImageThumbnailModal .product-image-img {\n  width: 100%;\n}\n\n.BC-Page__SelectImageThumbnailModal .product-default-images .product-image-wrapper .Polaris-Icon {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: rgba(44, 110, 203, 1);\n}\n\n.BC-Page__SelectImageThumbnailModal\n  .product-default-images\n  .product-image-wrapper\n  .Polaris-Icon\n  svg {\n  fill: rgba(255, 255, 255, 1);\n}\n\n.BC-Page__SelectImageVolumeModal .Polaris-Modal-Section > div {\n  display: flex;\n  gap: 10px;\n  align-items: start;\n}\n\n.BC-Page__SelectImageVolumeModal .product-image-div {\n  max-width: 112px;\n  width: 112px;\n  height: 144px;\n  padding: 8px;\n  border: 1px solid #e1e3e5;\n  border-radius: 4px;\n}\n.BC-Page__SelectImageVolumeModal .product-image {\n  max-width: 100%;\n  height: auto;\n}\n.custom-dropzone-bundle {\n  padding-top: 0;\n}\n\n.custom-dropzone-bundle.uploaded {\n  display: flex;\n  gap: 8px;\n}\n\n.custom-dropzone-bundle.uploaded .dropzone-area {\n  width: 40%;\n}\n\n.custom-dropzone-bundle .dropzone-content {\n  background: #e5effd;\n  padding: 4px 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1f5199;\n  width: fit-content;\n  border-radius: 4px;\n  margin: 0 auto 8px;\n}\n\n.custom-dropzone-bundle .Polaris-TextStyle--variationSubdued {\n  font-size: 12px;\n}\n\n.custom-dropzone-bundle.uploaded-error .Polaris-DropZone {\n  color: #d82c0d;\n  size: 12px;\n  font-weight: 600;\n  min-height: 76px;\n  align-items: center;\n  background-color: #fff4f4;\n}\n\n.custom-dropzone-bundle.uploaded-error\n  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled),\n.custom-dropzone-bundle.uploaded-error\n  .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled):hover::after {\n  border-color: #fd5749;\n}\n\n.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error {\n  text-align: center;\n  font-size: 12px;\n}\n.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error > p:first-child {\n  font-weight: 600;\n}\n\n.custom-dropzone-bundle.uploaded-error .Polaris-DropZone .dropzone-error > p:last-child {\n  font-weight: 400 !important;\n}\n\n/* Product */\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_general-page-with-product-display\n  .boost-sd__product-list {\n  margin: 24px 32px;\n  gap: 32px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_general-page-with-product-display\n  .boost-sd__product-item {\n  width: calc(33.33% - 32px);\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_general-page-with-product-display\n  .boost-sd__product-item\n  .boost-sd__product-image {\n  min-height: 372px;\n}\n\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_general-page-with-product-display\n  .boost-sd__product-item\n  .product-info\n  .Polaris-SkeletonBodyText.skeleton-80Width {\n  max-width: none;\n}\n\n/* Tiered Discount Progress Bar */\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status {\n  margin-bottom: 24px;\n  max-width: 560px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .tiered-progress-bar {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-icon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-icon svg {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #2c3e50;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-bars {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0;\n  position: relative;\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  position: relative;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier .tier-icon {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  z-index: 2;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier .tier-icon svg {\n  width: 28px;\n  height: 28px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .tier-connector {\n  width: 78%;\n  height: 4px;\n  background: #d2d5d8;\n  position: relative;\n  margin: 0 8px;\n  align-self: flex-start;\n  margin-top: 13px;\n  z-index: 1;\n  position: absolute;\n  margin-left: 44px;\n  margin-right: 40px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .tier-connector.active {\n  background: #008060;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier .tier-label {\n  text-align: center;\n  background: #ffffff;\n  border-radius: 6px;\n  padding: 8px 12px;\n  min-width: 100px;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 18px;\n  vertical-align: middle;\n  color: #8c9196;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier.active .tier-label,\n.PFS-PredictiveBundleItem .widget-visual-editor .discount-status .progress-tier.passed .tier-label {\n  color: #008060;\n  font-weight: 700;\n}\n\n/* Added Preview Bar */\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar > div:first-child {\n  background: #f4f4f4;\n  border: 1px solid #c9cccf;\n  border-radius: 6px;\n  padding: 8px 14px;\n  margin-top: 2px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .no-products {\n  text-align: center;\n  color: #6d7175;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 12px 0;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .products-preview {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .product-images {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .product-image-item {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 1px solid #e1e3e5;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .product-image-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .items-count {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6d7175;\n  flex-shrink: 0;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_tiered-page .add-to-cart {\n  padding: 12px !important;\n  max-width: none;\n  border-radius: 80px;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_vertical-product .add-to-cart {\n  width: 100%;\n}\n\n.PFS-PredictiveBundleItem .bundle-preview_horizontal-product .add-to-cart {\n  margin: 0 auto !important;\n  min-width: 112px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .see-all-link {\n  margin-left: auto;\n  background: none;\n  border: none;\n  color: #2c6ecb;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .see-all-link:hover {\n  text-decoration: underline;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .total-price-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 12px 0;\n}\n.PFS-PredictiveBundleItem\n  .widget-visual-editor\n  .bundle-preview_horizontal-product\n  .added-preview-bar\n  .total-price-section {\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 16px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .total-label {\n  font-size: 16px;\n  font-weight: 400;\n  color: #202223;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .price-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .price-after-discount {\n  font-size: 16px;\n  font-weight: 600;\n  font-family: Poppins;\n  color: #202223;\n}\n\n.PFS-PredictiveBundleItem .widget-visual-editor .added-preview-bar .price-before-discount {\n  font-size: 14px;\n  font-weight: 400;\n  color: #6d7175;\n  font-family: Poppins;\n  text-decoration: line-through;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
